import Translatable from '@/components/translatable_text/Translatable';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from '@mui/material';
import MessageRow from './MessageRow';
import { MessageItems, MessagesProps, TableHeadListProps } from '@/types/admin_types';

const tableHeadList = [
  { id: 231, title: '#', color: '', width: 100 },
  { id: 232, title: 'Message Title', color: '', width: 150 },
  { id: 233, title: 'Email', color: '', width: 150 },
  { id: 234, title: 'Phone', color: '', width: 150 },
  { id: 236, title: 'Action', color: '', width: 150 },
]

type Props = {
  data: MessagesProps;
}

export default function MessageTable({ data }: Props) {

  return (
    <div className='border rounded-md'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeadList.map((elList: TableHeadListProps) => (
                <TableCell key={elList.id} width={elList.width}>
                  <Stack spacing={2} direction="row">
                    <Typography variant="h6" color='#64758b' fontSize={16}>
                      <Translatable>
                        {elList.title}
                      </Translatable>
                    </Typography>
                  </Stack>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.items?.map((el: MessageItems, index: number) => (
              <MessageRow el={el} key={el.id} index={index}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>

  )
}
